import { Link } from 'react-router-dom'
import styled from 'styled-components'

export const BlogImageContainer = styled.div`
  height: 200px;
  width: 100%;
  margin-bottom: 20px;
  display: flex;
  justify-content: center;
  
  img {
    height: 100%;
    object-fit: contain;
  }
  @media screen and (min-width: 1100px) {
    height: 152px;
  }

`

export const BlogTitle = styled.h2`
  font-size: ${props => props.theme.font.size.md};
  font-family: ${props => props.theme.font.family.medium};
  color: ${props => props.theme.color.black};
  margin-bottom: 10px;
  @media screen and (min-width: 1100px) {

  }
`

export const BlogDescription = styled.p`
  font-size: 15px;
  color: ${props => props.theme.color.black};
  line-height: 1.47;
  margin-bottom: 30px;
  @media screen and (min-width: 1100px) {

  }
`

export const BlogCategory = styled.span`
  font-size: ${props => props.theme.font.size.sm};
  color: ${props => props.theme.color.grey4A};
  @media screen and (min-width: 1100px) {

  }
`

export const BlogTime = styled.span`
  font-size: ${props => props.theme.font.size.sm};
  color: ${props => props.theme.color.grey};
  @media screen and (min-width: 1100px) {

  }
`

export const BlogAnotherInfo = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 37px;
  position: absolute;
  bottom: 0;
  display: flex;
  width: 100%;
  justify-content: space-between;
  @media screen and (min-width: 1100px) {

  }
`

export const BlogItemContainer = styled(Link)`
  display: flex;
  height: 100%;
  flex-direction: column;
  flex: 1;
  position: relative;
  text-decoration: none;
  border-radius: 6px;
  border: 1px solid ${props => props.theme.color.greyED};
  padding: 20px 20px 15px 20px;
  & > div {
    position:relative;
    height: 100%;
  }
  @media screen and (min-width: 1100px) {
    /* max-width: 328px; */
  }
`
